import { UNIT_IMPERIAL } from '../constants.js';
import { metersToKm } from '../conversions/meters-to-km.js';
import { metersToMi } from '../conversions/meters-to-mi.js';
/**
 * The distance formatter floors converted values. Because we store most
 * distances as floats, we cannot accurately represent distances to a
 * precision that guarantees the value we read will be exactly the same
 * value that we tried to write. This manifests as user-facing distance
 * errors.
 *
 * For example, a 10 mile manual entry will be stored as 16093.44
 * meters. This converts back to 9.9999 miles and floors to 9.9.
 * Thus, we add a small buffer to distances before formatting.
 * Note that up until 2 decimal places of precision, adding a 1 meter
 * buffer should not change the displayed distance in units of kilometers or
 * miles. i.e. 10.0 miles/kilometers will display as 10.00 miles/kilometers,
 * as 1 meter is less than a hundredth of 1 mile/kilometer.
 */
const FLOOR_BUFFER = 1.0;
export const getDistanceUnit = (system) => system === UNIT_IMPERIAL ? 'mile' : 'kilometer';
export const convertDistance = (_locale, system, meters, options = {}) => {
    meters += options.skipFloorBuffer ? 0 : FLOOR_BUFFER;
    return [
        system === UNIT_IMPERIAL ? metersToMi(meters) : metersToKm(meters),
        getDistanceUnit(system)
    ];
};
